import { httpClient } from './client';

export type PrinterItem = {
  printerId: string;
  name: string;
  ipAddress: string;
  categoryIds: string[];
  isActive: boolean;
};

const fetchPrinters = () => {
  return httpClient().get<{ printers: PrinterItem[] | null }>(
    '/api/v2/printers'
  );
};

export const api = {
  fetchPrinters,
};
